import React, { FC } from 'react';

const PasswordIcon: FC<{ isOpen: boolean }> = ({ isOpen }) =>
  isOpen ? (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M0.833344 9.99992C0.833344 9.99992 4.16668 3.33325 10 3.33325C15.8333 3.33325 19.1667 9.99992 19.1667 9.99992C19.1667 9.99992 15.8333 16.6666 10 16.6666C4.16668 16.6666 0.833344 9.99992 0.833344 9.99992Z"
        stroke="#444444"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        stroke="#444444"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M18.2587 19.8029C18.5002 20.0574 18.8866 20.0739 19.1361 19.8029C19.3937 19.5318 19.3776 19.1623 19.1361 18.9077L5.67691 5.18478C5.43542 4.93841 5.03293 4.93841 4.79144 5.18478C4.55799 5.42294 4.55799 5.84177 4.79144 6.07993L18.2587 19.8029ZM12.004 5.65289C10.6034 5.65289 9.3315 5.89926 8.14819 6.30167L9.21076 7.37749C10.0962 7.10648 11.0059 6.95045 12.004 6.95045C17.3008 6.95045 21.5913 11.7136 21.5913 12.6909C21.5913 13.3561 20.1826 15.1464 17.9528 16.5425L18.9429 17.5527C21.4866 15.8691 23 13.66 23 12.6909C23 11.0074 18.5082 5.65289 12.004 5.65289ZM12.004 19.7289C13.5013 19.7289 14.8697 19.4579 16.1175 19.0227L15.0629 17.9469C14.105 18.2507 13.0907 18.4314 12.004 18.4314C6.69923 18.4314 2.40871 13.8489 2.40871 12.6909C2.40871 12.116 3.89791 10.2026 6.27259 8.74896L5.27442 7.73062C2.59385 9.42238 1 11.6972 1 12.6909C1 14.3662 5.58031 19.7289 12.004 19.7289ZM16.1336 14.4894C16.3831 13.9392 16.5199 13.3233 16.5199 12.6909C16.5199 10.1204 14.5075 8.09197 12.004 8.09197C11.3681 8.09197 10.7724 8.23158 10.2331 8.46974L16.1336 14.4894ZM12.004 17.2899C12.7124 17.2899 13.3805 17.1092 13.9762 16.8135L7.93889 10.6542C7.64105 11.262 7.47201 11.9518 7.47201 12.6909C7.48006 15.1957 9.48445 17.2899 12.004 17.2899Z"
        fill="#A7B3BE"
      />
    </svg>
  );

export default PasswordIcon;
